import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchReportCatalog, runReport } from "./reports.api";
import { keys } from "./keys";

export const useReportsCatalogQuery = () => {
    return useQuery({
        queryKey: keys.reports.catalog(),
        queryFn: fetchReportCatalog,
        placeholderData: (prev) => prev
    });
};

export const useRunReport = (successCallback = null, errorCallback = null) => {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: runReport,
        onSuccess: (data, variables) => {
            qc.setQueryData(keys.reports.result(variables.reportId, variables.parameters), data);

            if (successCallback) {
                successCallback(data);
            }
        },
        onError: (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    });
};
